
const Section4 = ({url}) => {
 
  const techIconPath = (iconKey) => `${url}images/offshoreDevelopment/sec4/${iconKey}.png`;

  const stacks = [
{
      category: "Frontend",
      cardColor: "blue",
      techs: [
        { name: "React JS",    bold: true,  img: "React JS"   },
        { name: "Angular",     bold: true,  img: "Angular"    },
        { name: "Vue.js",      bold: false, img: "Vue.js"     },
        { name: "TypeScript",  bold: true,  img: "TypeScript" },
        { name: "JavaScript",  bold: false, img: "JS"         },
        { name: "HTML5",       bold: false, img: "HTML"       },
        { name: "CSS3",        bold: false, img: "CSS"        },
        { name: "Bootstrap",   bold: false, img: "Bootstrap"  },
      ],
    },
    {
      category: "Backend",
      cardColor: "pink",
      techs: [
        { name: ".NET",     bold: true,  img: "dotNet"    },
        { name: "Java",     bold: true,  img: "Java"    },
        { name: "Python",   bold: true,  img: "python"  },
        { name: "Node.js",  bold: true,  img: "node Js" },
        { name: "PHP",      bold: false, img: "PHP"     },
      ],
    },
    {
      category: "Full-Stack",
      cardColor: "green",
      techs: [
        { name: "MEAN", bold: false, img: "MEAN" },
        { name: "MERN", bold: true,  img: "MERN" },
      ],
    },
    {
      category: "Mobile",
      cardColor: "peach",
      techs: [
        { name: "Flutter", bold: true,  img: "Flutter" },
        { name: "Kotlin",  bold: true,  img: "Kotlin"  },
        { name: "Java",    bold: false, img: "java."   },
      ],
    },
    {
      category: "DevOps & Cloud",
      cardColor: "yellow",
      techs: [
        { name: "Docker",        bold: true,  img: "Docker"        },
        { name: "Kubernetes",    bold: true,  img: "Kubernetes"    },
        { name: "Jenkins",       bold: false, img: "jenkins"       },
        { name: "Elastic",       bold: false, img: "Elastic"       },
        { name: "CI/CD",         bold: false, img: "CI-CD"         },
        { name: "Prometheus",    bold: false, img: "Prometheus"    },
        { name: "AWS",           bold: true,  img: "AWS"           },
        { name: "Digital Ocean", bold: false, img: "Digital Ocean" },
      ],
    },
    {
      category: "Database",
      cardColor: "white",
      techs: [
        { name: "SQL",           bold: true,  img: "SQL"           },
        { name: "MongoDB",       bold: true,  img: "MongoDB"       },
        { name: "PostgreSQL",    bold: true,  img: "PostgreSQL"    },
        { name: "Amazon RDS",    bold: false, img: "aws (2)"       },
        { name: "Amazon Aurora", bold: false, img: "Amazon Aurora" },
        { name: "Amazon S3",     bold: false, img: "Amazon s3"     },
      ],
    },
    {
      category: "Big Data & BI",
      cardColor: "purple",
      techs: [
        { name: "Hadoop",      bold: false, img: "Hadoop"      },
        { name: "Spark",       bold: false, img: "Spark"       },
        { name: "Cassandra",   bold: false, img: "cassandra"   },
        { name: "Tableau",     bold: false, img: "Tableau"     },
        { name: "Informatica", bold: false, img: "Informatica" },
        { name: "ZooKeeper",   bold: false, img: "ZooKeeper"   },
        { name: "Hive",        bold: false, img: "Hive"        },
      ],
    },
  ];
 
  return (
    <section className="home-section-4">
      <div className="container overflow-hidden">
 
        <h2 className="s4-title" data-aos="fade-up">
          Hire Dedicated Developers Across <br/> the Stacks That Matter
        </h2>
        <p className="s4-subtitle" data-aos="fade-up" data-aos-delay="100">
          Our offshore teams cover the full modern development stack with deepest talent pool and
          verified delivery track record.
        </p>
 
        <div className="s4-grid overflow-hidden">
          {stacks.map((stack, idx) => (
            <div
             className={`s4-stack-block s4-stack-block--${stack.cardColor}`}
              key={idx}
              data-aos="fade-up"
              data-aos-delay={idx * 80}
            >
              <h3 className="s4-category">{stack.category}</h3>
              <div className="s4-techs">
                {stack.techs.map((tech, i) => (
                  <div
                    className={`s4-tech-item ${tech.bold ? "s4-tech-item--bold" : ""}`}
                    key={i}
                    title={tech.name}
                  >
                    <div className="s4-tech-icon">
                      <img
                        src={`${url}/images/offshoreDevelopment/sec4/${tech.img}.png`}
                        alt={tech.name}
                        loading="lazy"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

 
      </div>
    </section>
  );
};
 
export default Section4;
 
